module.exports = __webpack_public_path__ + "static/DS_birthday_debut-d6fbfac1023f5824663d25a82297072e.jpeg";